import React from 'react';
import { Input } from 'antd';

const { Search } = Input;

const SearchApp = ({ setAppId }) => {
    const [value, setValue] = React.useState(null);

    const handleChange = (e) => {
        const newValue = e.target.value.replace(/\D/g, ''); // keep only numbers
        setValue(newValue);
    };

    const onSearch = (value) => {
        setAppId(value);
    };

    return (
        <div className='search-app'>
            <Search
                placeholder='Search by App Id'
                allowClear
                enterButton
                value={value}
                onSearch={onSearch}
                onChange={handleChange}
            />
        </div>
    );
};

export default SearchApp;
